import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV === "development";
export const logger = {
  log: (...messages: any[]) => {
    if (isDev) {
      console.log(...messages);
    }
  },
  warn: (...args: any[]) => {
    if (isDev) {
      console.warn(...args);
    }
  },
  error: (...args: any[]) => {
    if (isDev) {
      console.error(...args);
    }
  },
};

export const captureError = (error: any, errorObject?: any) => {
  console.error(error, errorObject);
  Sentry.withScope(function (scope) {
    scope.setLevel("error");

    Sentry.captureException({
      error,
      errorObject,
    });
  });
};
